import React, { useContext, useEffect, useState } from "react";
//LAYOUT COMPONENTS
import Menu from "../comun/Menu/Menu";
import Item from "../comun/Menu/Item";
import Footer from "../Footer";
import { AuthContext } from "../../context/auth";
import imgPresupuesto from "../../imagenes/fd_gestion_control-removebg-preview.png";

const op = require("../../modulos/datos");

export default function GestionControl() {
  const { user } = useContext(AuthContext);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
    }
  }, []);

  const presupuestariosItem = {
    title: "Presupuestos",
    icon: "fa fa-chart-pie me-2",
    drop: [
      {
        title: "Presupueto de Ingreso",
        icon: "fa fa-money-bill me-2",
        itemClickValue: 1,
      },
      {
        title: "Estados Financieros ►",
        icon: "fa fa-file me-2",
        itemClickValue: 2,
        subDrop: [
          {
            title: "Unidad Ejecutora",
            icon: "fa fa-file me-2",
            itemClickValue: 3,
          },
          {
            title: "Realcion de Obras",
            icon: "fa fa-file me-2",
            itemClickValue: 4,
          },
          {
            title: "Resumen General de Poyectos",
            icon: "fa fa-file me-2",
            itemClickValue: 5,
          },
          {
            title: "Disponibilidad Presupuestaria por Partidas",
            icon: "fa fa-search me-2",
            itemClickValue: 6,
          },
        ],
      },
      {
        title: "Estado Financiero Mensual de Gasto ►",
        icon: "fa fa-calendar me-2",
        itemClickValue: 7,
        subDrop: [
          {
            title: "Nivel Partidas de Cuentas",
            icon: "fa fa-file me-2",
            itemClickValue: 8,
          },
          {
            title: "Nivel SubEspecíficas/Cat. Programatica",
            icon: "fa fa-file me-2",
            itemClickValue: 9,
          },
          {
            title: "Nivel de Categorias Programaticas ►",
            icon: "fa fa-file me-2",
            subDrop: [
              {
                title: "Sectores",
                icon: "fa fa-save me-2",
                itemClickValue: 10,
              },
              {
                title: "Programas",
                icon: "fa fa-save me-2",
                itemClickValue: 11,
              },
              {
                title: "subProgramas",
                icon: "fa fa-save me-2",
                itemClickValue: 12,
              },
              {
                title: "Proyectos",
                icon: "fa fa-save me-2",
                itemClickValue: 13,
              },
              {
                title: "Actividad",
                icon: "fa fa-save me-2",
                itemClickValue: 14,
              },
            ],
          },
          {
            title: "Disponibilidad del Periodo por Partidas",
            icon: "fa fa-search me-2",
            itemClickValue: 15,
          },
          {
            title: "Resumen General de Obras",
            icon: "fa fa-file me-2",
            itemClickValue: 16,
          },
          {
            title: "Disponibilidad del Periodo General",
            icon: "fa fa-search me-2",
            itemClickValue: 17,
          },
          {
            title: "Analitico dpor Partidas",
            icon: "fa fa-search me-2",
            itemClickValue: 18,
          },
          {
            title: "Resumen General de Obras",
            icon: "fa fa-file me-2",
            itemClickValue: 19,
          },
          {
            title: "Ejecución del Gasto por Partidas",
            icon: "fa fa-search me-2",
            itemClickValue: 20,
          },
          {
            title: "Ejecución del Gasto Por Cuentas",
            icon: "fa fa-search me-2",
            itemClickValue: 21,
          },
          {
            title: "Ejecución del Gasto por Programaticas",
            icon: "fa fa-search me-2",
            itemClickValue: 22,
          },
        ],
      },
      {
        title: "Movimientos del Presupuesto ►",
        icon: "fa fa-money-bill me-2",
        subDrop: [
          {
            title: "Aumento y/o Crédito Adicional",
            icon: "fa fa-arrow-up me-2",
            itemClickValue: 23,
          },
          {
            title: "Reducción",
            icon: "fa fa-arrow-down me-2",
            itemClickValue: 24,
          },
          {
            title: "Traslado",
            icon: "fa fa-arrows-alt me-2",
            itemClickValue: 25,
          },
          {
            title: "Nivel de Partidas",
            icon: "fa fa-file me-2",
            itemClickValue: 26,
          },
          {
            title: "Nivel de Subespecificas",
            icon: "fa fa-file me-2",
            itemClickValue: 27,
          },
          {
            title: "Nivel de Subespecificas por Sector",
            icon: "fa fa-file me-2",
            itemClickValue: 28,
          },
          {
            title: "Partidas Creadas a Posteriori",
            icon: "fa fa-file me-2",
            itemClickValue: 29,
          },
        ],
      },
      {
        title: "Compromisos (Ord. Compra/Servicio) ►",
        icon: "fa fa-money-check me-2",
        subDrop: [
          {
            title: "Listado de Compromisos por Pagar ►",
            icon: "fa fa-file me-2",
            subDrop: [
              {
                title: "Listado de Compromisos por Fecha",
                icon: "fa fa-search me-2",
                itemClickValue: 31,
              },
              {
                title: "Listado de Compromisos por Proveedor",
                icon: "fa fa-search me-2",
                itemClickValue: 32,
              },
            ],
          },
          {
            title: "Listado por Tipo de Compromiso ",
            icon: "fa fa-file me-2",
            itemClickValue: 33,
          },
        ],
      },
      {
        title: "Solicitud de Donación",
        icon: "fa fa-money-bill me-2",
        itemClickValue: 34,
      },
      {
        title: "Aprobar Solicitu de Donación",
        icon: "fa fa-file me-2",
        itemClickValue: 35,
      },
    ],
  };
  const financierosItem = {
    title: "Financieros",
    icon: "fa fa-money-bill me-2",
    drop: [
      {
        title: "Ordenes de Pago ►",
        icon: "fa fa-file me-2",
        subDrop: [
          {
            title: "Listado General de Ordenes de Pago",
            icon: "fa fa-search me-2",
            itemClickValue: 36,
          },
          {
            title: "Ordenes de Pago por Tipo de compromiso",
            icon: "fa fa-search me-2",
            itemClickValue: 37,
          },
          {
            title: "Ordenes de Pago por Beneficiarios",
            icon: "fa fa-search me-2",
            itemClickValue: 38,
          },
          {
            title: "Ubicación de las Ordenes de Pago",
            icon: "fa fa-search me-2",
            itemClickValue: 39,
          },
          {
            title: "Partidas X Orden de Pago",
            icon: "fa fa-search me-2",
            itemClickValue: 40,
          },
          {
            title: "Partidas X Orden de Pago (clasificador Presupuestario)",
            icon: "fa fa-search me-2",
            itemClickValue: 41,
          },
        ],
      },
      {
        title: "Bancos ►",
        icon: "fa fa-building me-2",
        subDrop: [
          {
            title: "Saldo en Banco",
            icon: "fa fa-search me-2",
            itemClickValue: 42,
          },
          {
            title: "Libro de Banco",
            icon: "fa fa-search me-2",
            itemClickValue: 43,
          },
          {
            title: "Cheques Emitidos",
            icon: "fa fa-search me-2",
            itemClickValue: 44,
          },
          {
            title: "Control de Cheques",
            icon: "fa fa-search me-2",
            subDrop: [
              {
                title: "Cheques Devueltos",
                icon: "fa fa-search me-2",
                itemClickValue: 45,
              },
              {
                title: "Cheques Recuperados",
                icon: "fa fa-search me-2",
                itemClickValue: 46,
              },
            ],
          },
          {
            title: "Relacion de Egresos",
            icon: "fa fa-search me-2",
            itemClickValue: 47,
          },
          {
            title: "Transferencias Bancarias",
            icon: "fa fa-search me-2",
            itemClickValue: 48,
          },
          {
            title: "Depositos de Caja",
            icon: "fa fa-search me-2",
            itemClickValue: 49,
          },
          {
            title: "Conciliaciones",
            icon: "fa fa-search me-2",
            itemClickValue: 50,
          },
          {
            title: "Cheques Anulados",
            icon: "fa fa-search me-2",
            itemClickValue: 51,
          },
          {
            title: "Movimientos por Conciliar",
            icon: "fa fa-search me-2",
            itemClickValue: 52,
          },
          {
            title: "Notas de Débito y de Crédito",
            icon: "fa fa-search me-2",
            itemClickValue: 53,
          },
        ],
      },
      {
        title: "Retenciones ►",
        icon: "fa fa-money-bill me-2",
        subDrop: [
          {
            title: "Planilla de Retencion/Orden de Pago",
            icon: "fa fa-search me-2",
            itemClickValue: 54,
          },
          {
            title: "Listado de Retenciones",
            icon: "fa fa-search me-2",
            itemClickValue: 55,
          },
          {
            title: "Retenciones Declaradas",
            icon: "fa fa-search me-2",
            itemClickValue: 56,
          },
          {
            title:
              "Retenciones por Trasladar/Trasladas a Ctas Fondo de Terceros",
            icon: "fa fa-search me-2",
            itemClickValue: 57,
          },
          {
            title: "Retenciones por Enterar por Proveedor (Fondo de Terceros)",
            icon: "fa fa-search me-2",
            itemClickValue: 58,
          },
          {
            title: "Rtenciones Enteradas por Proveedor (Fondo de Terceros)",
            icon: "fa fa-search me-2",
            itemClickValue: 59,
          },
          {
            title: "Retenciones Realizadas - Agrupadas por Bancos",
            icon: "fa fa-search me-2",
            itemClickValue: 60,
          },
          {
            title: "Resumen de Retenciones Anuales por Beneficiario",
            icon: "fa fa-search me-2",
            itemClickValue: 61,
          },
        ],
      },
      {
        title: "Fondo de Terceros",
        icon: "fa fa-money-bill me-2",
        subDrop: [
          {
            title: "Listado General Fondos de Terceros",
            icon: "fa fa-search me-2",
            itemClickValue: 62,
          },
          {
            title: "Retenciones por Declarar",
            icon: "fa fa-search me-2",
            itemClickValue: 63,
          },
          {
            title: "Reteciones por Declarar",
            icon: "fa fa-search me-2",
            itemClickValue: 64,
          },
        ],
      },
    ],
  };
  const controlItem = {
    title: "Control",
    icon: "fa fa-folder me-2",
    drop: [
      {
        title: "Inversion y Compras ►",
        icon: "fa fa-money-bill me-2",
        subDrop: [
          {
            title: "Ingeniería",
            icon: "fa fa-building me-2",
            itemClickValue: 65,
          },
          {
            title: "Listado General de Obras",
            icon: "fa fa-search me-2",
            itemClickValue: 66,
          },
          {
            title: "Listado de Obras Asignadas",
            icon: "fa fa-search me-2",
            itemClickValue: 67,
          },
          {
            title: "Relación de Pagos de Obras",
            icon: "fa fa-search me-2",
            itemClickValue: 68,
          },
          {
            title: "Relación de Pagos de Obras",
            icon: "fa fa-search me-2",
            itemClickValue: 69,
          },
          {
            title: "Resumen General de Obras",
            icon: "fa fa-search me-2",
            itemClickValue: 70,
          },
          {
            title: "Compras",
            icon: "fa fa-money-bill me-2",
            itemClickValue: 71,
          },
          {
            title: "Listado Solicitud de Requisiciones",
            icon: "fa fa-search me-2",
            itemClickValue: 72,
          },
          {
            title: "Listado Solicitudes de Compras",
            icon: "fa fa-search me-2",
            itemClickValue: 73,
          },
          {
            title: "Supervisor ►",
            icon: "fa fa-user me-2",
            subDrop: [
              {
                title: "Ordenes de Compra por Proveedor",
                icon: "fa fa-save me-2",
                itemClickValue: 74,
              },
            ],
          },
        ],
      },
      {
        title: "Hacienda Municipal ►",
        icon: "fa fa-building me-2",
        subDrop: [
          {
            title: "Analisis de Deudas ►",
            icon: "fa fa-money-bill me-2",
            subDrop: [
              {
                title: "Recuperación de Deudas",
                icon: "fa fa-search me-2",
                itemClickValue: 75,
              },
              {
                title: "Listado Gral. Deuda/Contribuyente",
                icon: "fa fa-search me-2",
                itemClickValue: 76,
              },
            ],
          },
          {
            title: "Resumen de Caja",
            icon: "fa fa-search me-2",
            itemClickValue: 77,
          },
          {
            title: "Listado deudas de Contribuyentes ►",
            icon: "fa fa-search me-2",
            subDrop: [
              {
                title: "Actividades Económicas",
                icon: "fa fa-money-bill me-2",
                itemClickValue: 78,
              },
              {
                title: "Propiedad Inmobiliaria",
                icon: "fa fa-building me-2",
                itemClickValue: 79,
              },
              {
                title: "Publicidad Comercial",
                icon: "fa fa-user me-2",
                itemClickValue: 80,
              },
              {
                title: "Impuesto de vehículos",
                icon: "fa fa-car me-2",
                itemClickValue: 81,
              },
              {
                title: "Impuesto de Licores",
                icon: "fa fa-wine-glass me-2",
                itemClickValue: 82,
              },
              {
                title: "Rentas Inmobiliarias",
                icon: "fa fa-building me-2",
                itemClickValue: 83,
              },
              {
                title: "Apuestas Lícitas",
                icon: "fa fa-dice me-2",
                itemClickValue: 84,
              },
            ],
          },
          {
            title: "Efectividad",
            icon: "fa fa-suitcase me-2",
            itemClickValue: 85,
          },
          {
            title: "Facturación ►",
            icon: "fa fa-pen me-2",
            subDrop: [
              {
                title: "Listado de Facturas Emitidas",
                icon: "fa fa-search me-2",
                itemClickValue: 86,
              },
              {
                title: "Listado de Facturas por Cobrar",
                icon: "fa fa-search me-2",
                itemClickValue: 87,
              },
              {
                title: "Listado de Facturas Cobradas",
                icon: "fa fa-search me-2",
                itemClickValue: 88,
              },
              {
                title: "Listado de Facturas Anuladas",
                icon: "fa fa-search me-2",
                itemClickValue: 89,
              },
              {
                title: "Listado de Facturas por Tipo Impuesto",
                icon: "fa fa-search me-2",
                itemClickValue: 90,
              },
            ],
          },
        ],
      },
    ],
  };
  const configuracionItem = {
    title: "Configuración",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 91,
      },
    ],
  };

  const PorDefecto = () => {
      const azulProfundo = "#003a70";
      const azulVibrante = "#007bff";
  
      return (
        <section
          className="col-12 m-0 p-0"
          style={{ height: "90dvh", overflow: "hidden" }}
        >
          <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>
  
          <div
            className="col-md-12 row mx-auto px-0"
            style={{ minHeight: "100%" }}
          >
            <div
              className="col-md-6 d-flex justify-content-center align-items-center"
              style={{
                position: "relative",
                left: "-50px",
                borderBottomRightRadius: "30%",
                height: "90dvh",
                backgroundColor: azulProfundo,
                overflow: "hidden",
                boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
              }}
            >
              {/* 1. FONDO MESH GRADIENT (Profundidad) */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
                }}
              />
  
              {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                  backgroundSize: "50px 50px",
                }}
              />
  
              {/* 3. PUNTOS ANIMADOS (Partículas) */}
              <div
                className="tech-dot"
                style={{
                  width: "6px",
                  height: "6px",
                  top: "20%",
                  left: "15%",
                  animationDelay: "0s",
                }}
              />
              <div
                className="tech-dot"
                style={{
                  width: "4px",
                  height: "4px",
                  top: "60%",
                  left: "25%",
                  animationDelay: "1s",
                }}
              />
              <div
                className="tech-dot"
                style={{
                  width: "8px",
                  height: "8px",
                  top: "40%",
                  left: "80%",
                  animationDelay: "2s",
                }}
              />
              <div
                className="tech-dot"
                style={{
                  width: "3px",
                  height: "3px",
                  top: "80%",
                  left: "60%",
                  animationDelay: "1.5s",
                }}
              />
  
              {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                  transform: "skewX(-20deg)",
                }}
              />
  
              {/* LOGO CON GLOW */}
              <div
                style={{ position: "relative", zIndex: 10, textAlign: "center" }}
              >
                <img
                  style={{
                    filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                    maxWidth: "100%",
                    transition: "transform 0.3s ease",
                  }}
                  className="img-fluid"
                  src={imgPresupuesto}
                  alt="Logo SIAP"
                />
              </div>
            </div>
  
            {/* LADO DERECHO (Alcaldía) */}
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <img
                className="img-fluid px-5"
                src={op.imagenes + "/imagen?img=" + op.logohacienda}
                alt="Logo Alcaldía"
                style={{ maxWidth: "85%" }}
              />
            </div>
          </div>
        </section>
      );
    };

  const vista = {
    0: <PorDefecto />,
  };

  if (!user) return <></>;

  return (
    <div className="w-100 col-12 m-0 p-0">
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item
          item={presupuestariosItem}
          setTabla={setTabla}
          setShow={setShow}
        />
        <Item item={financierosItem} setTabla={setTabla} setShow={setShow} />
        <Item item={controlItem} setTabla={setTabla} setShow={setShow} />
        {/* <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} /> */}
        <a
          href="/inicio"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section
        className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
        style={{ height: "90dvh" }}
      >
        {vista[tabla]}
      </section>
      <Footer />
    </div>
  );
}
